/* eslint-disable react-refresh/only-export-components */
import { lazy, Suspense, type ReactNode } from 'react'
import { createHashRouter } from 'react-router-dom'
import MainLayout from '@/layouts/MainLayout'

const Home = lazy(() => import('@/pages/Home'))
const SmartLaborPerformance = lazy(
  () => import('@/pages/solutions/SmartLaborPerformance')
)
const YieldIntelligence = lazy(
  () => import('@/pages/solutions/YieldIntelligence')
)
const HarvestManagement = lazy(
  () => import('@/pages/solutions/HarvestManagement')
)
const ComingSoon = lazy(() => import('@/pages/ComingSoon'))

const LazyLoad = ({ children }: { children: ReactNode }) => (
  <Suspense fallback={<div />}>{children}</Suspense>
)

const router = createHashRouter([
  {
    path: '/',
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: (
          <LazyLoad>
            <Home />
          </LazyLoad>
        ),
      },
      {
        path: 'solutions/smart-labor-performance',
        element: (
          <LazyLoad>
            <SmartLaborPerformance />
          </LazyLoad>
        ),
      },
      {
        path: 'solutions/yield-intelligence',
        element: (
          <LazyLoad>
            <YieldIntelligence />
          </LazyLoad>
        ),
      },
      {
        path: 'solutions/harvest-management',
        element: (
          <LazyLoad>
            <HarvestManagement />
          </LazyLoad>
        ),
      },
      {
        path: 'customer-success',
        element: (
          <LazyLoad>
            <ComingSoon />
          </LazyLoad>
        ),
      },
      {
        path: 'partners',
        element: (
          <LazyLoad>
            <ComingSoon />
          </LazyLoad>
        ),
      },
      {
        path: '*',
        element: (
          <LazyLoad>
            <ComingSoon />
          </LazyLoad>
        ),
      },
    ],
  },
])

export default router
